import axios from "axios";
import { ENV_VARIABLES } from "../envVariables";

export const axiosInstance = axios.create({
    baseURL: `${ENV_VARIABLES.backendUrl}/wp-json/funnel-api`,
    timeout: 10000
});